import React, { Component } from 'react';
import { Flex, Text, Lookup } from 'core/components';
import { ReactComponent as PeeringdbIcon } from 'app/assets/logos/peeringdb-icon.svg';

import AdminTable from 'app/components/admin/AdminTable';
import RegionLink from 'app/components/links/RegionLink';
import CityLink from 'app/components/links/CityLink';
import CountryLink from 'app/components/links/CountryLink';
import SiteCollection from 'app/stores/site/SiteCollection';
import ToolResultCard from '../components/ToolResultCard';

class SiteInventoryToolResult extends Component {
  state = {
    collection: new SiteCollection()
  };

  componentDidMount() {
    const { collection } = this.state;
    const { tool } = this.props;
    const { raw_result = {} } = tool;
    collection.add(raw_result);
  }

  get columns() {
    return [
      {
        label: 'Site',
        name: 'title'
      },
      {
        label: 'Type',
        computed: true,
        name: 'type'
      },
      {
        label: 'City',
        name: 'city',
        renderer: ({ value, model }) => {
          if (value) {
            return (
              <CityLink city={value} country={model.get('country')} region={model.get('region')}>
                <Lookup lookup="cities" value={value} />
              </CityLink>
            );
          }
          return <Text muted>--</Text>;
        }
      },
      {
        label: 'Region',
        name: 'region',
        renderer: ({ value, model }) => {
          if (value) {
            return (
              <RegionLink country={model.get('country')} region={model.get('region')}>
                <Lookup lookup="regions" value={value} />
              </RegionLink>
            );
          }
          return <Text muted>--</Text>;
        }
      },
      {
        label: 'Country',
        name: 'country',
        renderer: ({ value }) => {
          if (value) {
            return (
              <CountryLink country={value}>
                <Lookup lookup="countries" value={value} />
              </CountryLink>
            );
          }
          return <Text muted>--</Text>;
        }
      },
      {
        label: 'Site Market',
        name: 'siteMarket.name'
      },
      {
        label: (
          <>
            <PeeringdbIcon style={{ width: 15, height: 15 }} />
            <Text pl={1}>PeeringDB Facility</Text>
          </>
        ),
        name: 'peeringdbSiteMapping',
        renderer: ({ value }) => {
          if (value && Array.isArray(value) && value.length > 0) {
            if (value.length === 1) {
              return <Lookup lookup="fac_id" value={value[0].fac_id} />;
            }
            return <Text>{`${value.length} Facilities selected`}</Text>;
          }
          return '';
        }
      }
    ];
  }

  render() {
    const { collection } = this.state;
    const { tool, onCloseToolResult, isInlineMode } = this.props;

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-site-inventory"
        title={tool.title || 'Site Inventory Result'}
      >
        <Flex flexDirection="column" px={1} pb={1} flex={1}>
          <AdminTable collection={collection} rowHeight={36} columns={this.columns} />
        </Flex>
      </ToolResultCard>
    );
  }
}

export default SiteInventoryToolResult;
